module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "page-title"
  }, [_vm._v("Successfully Submitted for Approval!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n        Your order has been successfully submitted for approval.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n        Your order will be reviewed within the next 2-3 business days. \n        You will receive an email either with your order confirmation or \n        informing you that your order was not approved.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n        Please note, the overall turn time for this order will be increased.\n    ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-244865f7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-244865f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Order/OrderSubmit/OrderSubmitComponent/OrderSpecial.vue
// module id = 470
// module chunks = 3